import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { PopoverPositions } from '@vendasta/galaxy/popover';
import { SelectedItem } from '../item-selector/interface';
import { PackageContentsService } from '../services/package-contents.service';

@Component({
  selector: 'inventory-ui-package-contents-popover',
  templateUrl: './package-contents-popover.component.html',
  styleUrls: ['./package-contents-popover.component.scss'],
})
export class PackageContentsPopoverComponent {
  protected readonly PopoverPositions = PopoverPositions;

  @Input() packageId = '';
  @Input() partnerId = '';
  @Input() marketId = '';

  packageItems$!: Observable<SelectedItem[]>;
  isOpen = false;

  constructor(private readonly packageContentsService: PackageContentsService) {}

  togglePopover(): void {
    if (!this.isOpen && !this.packageItems$) {
      this.packageItems$ = this.packageContentsService.fetchPackageItems(this.packageId, this.partnerId, this.marketId);
    }
    this.isOpen = !this.isOpen;
  }
}
